declare global {
  interface Window { umami?: { track(name: string, data?: Record<string, string | number | boolean>): void } }
}

const allowedEvents = new Set(["account_started", "account_created", "sign_in", "quiz_started", "quiz_completed", "praise_shown", "legacy_opened"]);

export function initializeAnalytics(): void {
  const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
  if (!websiteId) return;
  const script = document.createElement("script");
  script.defer = true;
  script.src = "/analytics/script.js";
  script.dataset.hostUrl = "/analytics";
  script.dataset.websiteId = websiteId;
  document.head.append(script);
}

export function track(name: string, data: Record<string, string | number | boolean> = {}): void {
  if (!allowedEvents.has(name)) return;
  window.umami?.track(name, data);
}
